import Cookies from "js-cookie";
import { getChannelId } from "./channel";

const memoryStorage = {};
let localStorageEnabled = true;
let cookieStorageEnabled = true;
let sessionStorageEnabled = true;
/**
 * Cookie Storage
 */
const CS = {
    get: (key) => (cookieStorageEnabled ? Cookies.get(key) : null),
    set: (key, value) => (cookieStorageEnabled ? Cookies.set(key, value) : null),
    del: (key) => (cookieStorageEnabled ? Cookies.remove(key) : null),
};
/**
 * Local Storage
 */
const LS = {
    get: (key) => (localStorageEnabled ? localStorage.getItem(key) : null),
    set: (key, value) => (localStorageEnabled ? localStorage.setItem(key, value) : null),
    del: (key) => (localStorageEnabled ? localStorage.removeItem(key) : null),
};

const SS = {
    get: (key) => (sessionStorageEnabled ? sessionStorage.getItem(key) : null),
    set: (key, value) => (sessionStorageEnabled ? sessionStorage.setItem(key, value) : null),
    del: (key) => (sessionStorageEnabled ? sessionStorage.removeItem(key) : null),
};
/**
 * Memory Storage
 */
const MS = {
    get: (key) => memoryStorage[key],
    set: (key, value) => (memoryStorage[key] = value),
    del: (key) => delete memoryStorage[key],
};

// Ek web chat kanalinda kimlik ve sohbet kayitlari kanala ayrilir; ana web chat'in anahtarlari degismez
const scoped = (key) => (getChannelId() ? `${key}-${getChannelId()}` : key);

export const getPersistenceData = function getPersistenceData(rawKey, defaultValue = null) {
    const key = scoped(rawKey);
    let value = CS.get(key) || LS.get(key) || MS.get(key) || defaultValue;
    if (["visitorId", "conversationId"].includes(rawKey)) {
        if ([null, undefined, "null", "undefined"].includes(value)) {
            value = defaultValue;
        }
    }
    return value;
};
export const setPersistenceData = (rawKey, value, onlyLocalStorage = false) => {
    const key = scoped(rawKey);
    const store = require("@/store").default;
    if (onlyLocalStorage) {
        MS.set(key, value);
        LS.set(key, value);
    } else {
        MS.set(key, value);
        LS.set(key, value);
        CS.set(key, value);
    }
    if (rawKey === "visitorId") {
        store.dispatch("chat/setVisitorId", value);
    }
    if (rawKey === "conversationId") {
        store.dispatch("chat/connectChat", value);
    }
};
export const removePersistenceData = (rawKey) => {
    const key = scoped(rawKey);
    CS.del(key);
    LS.del(key);
    MS.del(key);
};

export const getTempData = function getTempData(key, defaultValue = null) {
    return SS.get(key) || MS.get(key) || defaultValue;
};
export const setTempData = (key, value) => {
    MS.set(key, value);
    SS.set(key, value);
};
export const removeTempData = (key) => {
    SS.del(key);
    MS.del(key);
};

const checkLocalStorage = () => {
    try {
        const key = "ignore";
        const val = "1";
        LS.set(key, val);
        const ignore = LS.get(key);
        LS.del(key);
        localStorageEnabled = ignore === val;
    } catch (e) {
        localStorageEnabled = false;
    }
};
const checkCookieStorage = () => {
    try {
        const key = "ignore";
        const val = "1";
        CS.set(key, val);
        const ignore = CS.get(key);
        CS.del(key);
        cookieStorageEnabled = ignore === val;
    } catch (e) {
        cookieStorageEnabled = false;
    }
};

const checkSessionStorage = () => {
    try {
        const key = "ignore";
        const val = "1";
        SS.set(key, val);
        const ignore = SS.get(key);
        SS.del(key);
        sessionStorageEnabled = ignore === val;
    } catch (e) {
        sessionStorageEnabled = false;
    }
};

(() => {
    checkLocalStorage();
    checkCookieStorage();
    checkSessionStorage();
})();



// WEBPACK FOOTER //
// ./src/utils/persistenceStorage.js